import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';
import NextLink from 'components/NextLink';

import styles from './styles.module.scss';

const Place = ({ title, url, size, className, tabIndex, ariaHidden }) => {
	const placeCx = cx(styles.place, styles[`size_${size}`], className);

	return (
		<div className={placeCx} aria-hidden={ariaHidden}>
			<Icon icon="place" className={styles.icon} />
			{url ? (
				<NextLink
					href={url}
					className={styles.link}
					tabIndex={tabIndex}
					aria-hidden={ariaHidden}
				>
					{title}
				</NextLink>
			) : (
				<span
					tabIndex={tabIndex}
					className={styles.text}
					aria-hidden={ariaHidden}
				>
					{title}
				</span>
			)}
		</div>
	);
};

Place.propTypes = {
	className: PropTypes.string,
	title: PropTypes.string.isRequired,
	url: PropTypes.string,
	size: PropTypes.oneOf(['medium', 'large']),
	tabIndex: PropTypes.number,
	ariaHidden: PropTypes.bool
};

export default Place;
